import React from "react";
import { Add } from "@mui/icons-material";
import { HeaderButton } from "../button/HeaderButton";
import { CreateProgramTemplateDialog } from "../dialog/CreateProgramTemplateDialog";

export interface CreateProgramTemplateActionProps {
  disabled?: boolean;
  className?: string;
}

export function CreateProgramTemplateAction(
  props: CreateProgramTemplateActionProps,
) {
  const { disabled = false, className } = props;
  const [dialogOpen, setDialogOpen] = React.useState(false);

  const handleOpenDialog = React.useCallback(() => {
    setDialogOpen(true);
  }, []);

  const handleCloseDialog = React.useCallback(() => {
    setDialogOpen(false);
  }, []);

  return (
    <>
      <HeaderButton
        startIcon={<Add />}
        onClick={handleOpenDialog}
        disabled={disabled}
        className={className}
      >
        Create template
      </HeaderButton>

      {dialogOpen && (
        <CreateProgramTemplateDialog open={true} onClose={handleCloseDialog} />
      )}
    </>
  );
}

